import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { rootReducer } from "../features";
const store = configureStore({
    reducer:{
        root:rootReducer
    },
    middleware:getDefaultMiddleware({serializableCheck:false})    
})
export default store